import { useParams, useNavigate, useLocation } from 'react-router-dom';
import { useKnowledgeDocument, useKnowledgeDocuments } from '@/hooks/useKnowledge';
import { DocumentViewer } from '@/components/knowledge/DocumentViewer';
import { RelatedDocuments } from '@/components/knowledge/RelatedDocuments';
import { Button } from '@/components/ui/button';
import { Edit, ArrowLeft } from 'lucide-react';

export function KnowledgeViewPage() {
  const { id } = useParams<{ id: string }>();
  const navigate = useNavigate();
  const location = useLocation();

  const handleBack = () => {
    if (location.key !== 'default') {
      navigate(-1);
    } else {
      navigate('/knowledge');
    }
  };

  const { data: document, isLoading } = useKnowledgeDocument(id!);
  const { data: relatedDocs } = useKnowledgeDocuments({
    categorySlug: document?.categorySlug,
  });

  // Filter out current document from related
  const related = relatedDocs?.filter((d) => d.id !== id) || [];

  if (isLoading) {
    return (
      <div className="container mx-auto py-8">
        <div className="text-center py-12 text-muted-foreground">
          Carregando documento...
        </div>
      </div>
    );
  }

  if (!document) {
    return (
      <div className="container mx-auto py-8">
        <div className="text-center py-12 text-muted-foreground">
          Documento não encontrado
        </div>
      </div>
    );
  }

  return (
    <div className="container mx-auto py-8 space-y-8">
      <div className="flex items-center gap-4">
        <Button variant="ghost" onClick={handleBack}>
          <ArrowLeft className="h-4 w-4 mr-2" />
          Voltar
        </Button>
        <Button onClick={() => navigate(`/knowledge/${id}/edit`)}>
          <Edit className="h-4 w-4 mr-2" />
          Editar
        </Button>
        <Button variant="outline" onClick={() => navigate(`/knowledge/${id}/versions`)}>
          Ver Histórico
        </Button>
      </div>

      <DocumentViewer document={document} />

      {related.length > 0 && (
        <div className="space-y-4">
          <h2 className="text-2xl font-bold">Documentos Relacionados</h2>
          <RelatedDocuments
            documents={related}
            onDocumentClick={(relatedId) => navigate(`/knowledge/${relatedId}`)}
          />
        </div>
      )}
    </div>
  );
}
